import { render, staticRenderFns } from "./entrepreneurs.vue?vue&type=template&id=5af3117a&lang=html"
import script from "./entrepreneurs.vue?vue&type=script&lang=js"
export * from "./entrepreneurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports